// extracted by mini-css-extract-plugin
export var capright = "two-images-module--capright--9a4f6";
export var capt_acenter = "two-images-module--capt_acenter--44f0b";
export var capt_aright = "two-images-module--capt_aright--3c007";
export var captflex = "two-images-module--captflex--03d39";
export var caption = "two-images-module--caption--52b39";
export var copy_cta = "two-images-module--copy_cta--e99c1";
export var first = "two-images-module--first--c91c3";
export var himage = "two-images-module--himage--72d01";
export var hsubtitle = "two-images-module--hsubtitle--dcfa2";
export var item = "two-images-module--item--c57fb";
export var nd_hero = "two-images-module--nd_hero--c0309";
export var nodesk = "two-images-module--nodesk--c4643";
export var nomob = "two-images-module--nomob--fb9cc";
export var smaller = "two-images-module--smaller--cd590";
export var twoeq = "two-images-module--twoeq--6225c";
export var twooff = "two-images-module--twooff--42f1a";